<fre-root-builder 
  [rootSource]="this"
  [showNavigation]="showNav"
  [systemTitle]="'FRE Site Manager'">
  <router-outlet></router-outlet>
</fre-root-builder>

